import { useEffect } from 'react';

import CustomMetaData, {
  CustomMetaDataProps,
} from 'components/general/customMetaData/CustomMetaData';
import { PageIntroTextType } from 'components/pageIntroText/PageIntroText';
import { ProjectCard } from 'components/projectCard/ProjectCard';
import { useThemeContext } from 'context/ThemeContext';
import { getEndpoint } from 'utils/helpers';
import { getGlobalData, GlobalDataType } from 'utils/parsers';
import { widont } from 'utils/typography';
import { ProjectType } from './project/[id]';

import style from './index.module.scss';

type Props = {
  // title: string;
  metaData: CustomMetaDataProps;
  intro: PageIntroTextType;
  projects: ProjectType[];
} & { globalData: GlobalDataType };

const Index = ({
  intro,
  projects,
  metaData,
}: Props): JSX.Element => {
  const { setTheme } = useThemeContext();

  useEffect(() => {
    setTheme('dark');
  }, [setTheme]);

  return (
    <div>
      <CustomMetaData {...metaData} />
      <section className={style.projects}>
        {projects.map(({ thumb, slug, blurb, full_name: title }) => {
          return <ProjectCard
            key={slug}
            title={title}
            blurb={blurb}
            thumb={thumb}
            slug={'project/' + slug}
          />
        })}
      </section>
      <h2 className={style.intro} dangerouslySetInnerHTML={{ __html: intro.html }} />
    </div>
  );
};

export async function getStaticProps(context) {
  const homepage = await getEndpoint('/homepage/', context);
  const projects = await getEndpoint('/projects/', context);
  const globalData = await getGlobalData();

  const props: Props = {
    metaData: {
      titleDefault: homepage.title || '',
      title: homepage.meta_title,
      description: homepage.meta_description,
      image: homepage.meta_image,
    },
    intro: {
      html: widont(homepage.intro),
    },
    projects,
    globalData,
  };
  return {
    props,
    revalidate: NEXTJS_REVALIDATE_PAGE_IN_SECONDS,
  };
}

export const NEXTJS_REVALIDATE_PAGE_IN_SECONDS = 10;
export default Index;
